export const externalRoutes = {
    leads: `${process.env.REACT_APP_PAINEL_BASE_URL}contato`,
    imoveis: `${process.env.REACT_APP_PAINEL_BASE_URL}imoveis`,
    condominios: `${process.env.REACT_APP_PAINEL_BASE_URL}condominios`,
}